let routes = [
    {
        path: '/flow/create',
        name: 'flow-create',
        meta: {
            title: '创建审批',
            company: false,
            keepAlive: false,
            tabBar: true
        },
        component: () => import('../views/flow/create'),
        children: []
    }, {
        path: '/flow/detail',
        name: 'flow-detail',
        meta: {
            title: '详情',
            company: false,
            keepAlive: false,
            tabBar: true
        },
        component: () => import('../views/flow/detail'),
        children: []
    }, {
        path: '/flow/commit',
        name: 'flow-commit',
        meta: {
            title: '审批',
            keepAlive: false,
            company: false,
            tabBar: true
        },
        component: () => import('../views/flow/commit'),
        children: []
    }, {
        path: '/approve/index',
        name: 'approve',
        meta: {
            title: '审批',
            keepAlive: true, // 需要被缓存
            company: false,
            tabBar: true
        },
        component: () => import('../views/approve/index'),
        children: []
    }, {
        path: '/approve/choice',
        name: 'approve-choice',
        meta: {
            title: '选择审批单',
            keepAlive: false,
            company: false,
            tabBar: true
        },
        component: () => import('../views/approve/choiceList'),
        children: []
    }, {
        path: '/approve/detail',
        name: 'approve-detail',
        meta: {
            title: '审批详情',
            keepAlive: false,
            company: false,
            tabBar: true
        },
        component: () => import('../views/approve/detail'),
        children: []
    }, {
        path: '/approve/create',
        name: 'approve-create',
        meta: {
            title: '创建审批',
            keepAlive: false,
            company: false,
            tabBar: true
        },
        component: () => import('../views/approve/create'),
        children: []
    }, {
        path: '/approve/list',
        name: 'approve-list',
        meta: {
            title: '审批列表',
            keepAlive: true, // 需要被缓存
            company: false,
            tabBar: true
        },
        component: () => import('../views/approve/list'),
        children: []
    }, {
        path: '/approve/commit',
        name: 'approve-commit',
        meta: {
            title: '提交',
            keepAlive: false, // 需要被缓存
            company: false,
            tabBar: true
        },
        component: () => import('../views/approve/commit'),
        children: []
    }, {
        path: '/flow/force-commit',
        name: 'flow-force-commit',
        meta: {
            title: '提交',
            keepAlive: false, // 需要被缓存
            company: false,
            tabBar: true
        },
        component: () => import('../views/flow/force-commit'),
        children: []
    }];

export default routes;
